import { VariableActionType } from './action-types';
import { VariableState } from '@/constants';
import { VariableInfo } from '@/lib/PlannerDTOs';

// Traditional action creator if you need Redux actions
export const getVariable = () => {
  return {
    type: VariableActionType.GET_VARIABLE,
    payload: {},
  };
};

export const setVariable = (
  data: any,
  isLoading: boolean,
  error: Error | null,
) => {
  return {
    type: VariableActionType.SET_VARIABLE,
    payload: { data, isLoading, error },
  };
};

export const variableDetailUpdate = (
  variable: VariableInfo,
  variableIsValid: boolean,
) => {
  return {
    type: VariableActionType.VARIABLE_DETAIL_UPDATE,
    payload: { variable, variableIsValid },
  };
};

export const variableJsonSchemaUpdate = (
  jsonSchema: any | null,
  jsonSchemaIsValid: boolean,
) => {
  return {
    type: VariableActionType.VARIABLE_JSON_SCHEMA_UPDATE,
    payload: { jsonSchema, jsonSchemaIsValid },
  };
};

export const updateVariableState = (state: VariableState) => {
  return {
    type: VariableActionType.UPDATE_VARIABLE_STATE,
    payload: { state },
  };
};

export const updateVariableSuccess = (variable: VariableInfo) => {
  return {
    type: VariableActionType.UPDATE_VARIABLE_SUCCESS,
    payload: { variable },
  };
};

export const updateVariableProductEntity = (productEntity: string) => {
  return {
    type: VariableActionType.UPDATE_VARIABLE_PRODUCT_ENTITY,
    payload: { productEntity },
  };
};

export const updateVariableIsValid = (isValid: boolean) => {
  return {
    type: VariableActionType.UPDATE_VARIABLE_IS_VALID,
    payload: { isValid },
  };
};

export const setVariableDiff = (
  previousVariable: VariableInfo,
  currentVariable: VariableInfo,
) => {
  return {
    type: VariableActionType.SET_VARIABLE_DIFF,
    payload: { previousVariable, currentVariable },
  };
};

export const deleteVariable = (name: string) => {
  return {
    type: VariableActionType.DELETE_VARIABLE,
    payload: { name },
  };
};

// Action type union for type safety
export type VariableAction =
  | ReturnType<typeof getVariable>
  | ReturnType<typeof setVariable>
  | ReturnType<typeof variableDetailUpdate>
  | ReturnType<typeof variableJsonSchemaUpdate>
  | ReturnType<typeof updateVariableState>
  | ReturnType<typeof updateVariableSuccess>
  | ReturnType<typeof updateVariableProductEntity>
  | ReturnType<typeof updateVariableIsValid>
  | ReturnType<typeof setVariableDiff>
  | ReturnType<typeof deleteVariable>;
